"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSettings = void 0;

var _reactQuery = require("react-query");

var _api = require("../api");

var _types = require("../types");

var useSettings = function useSettings() {
  return (0, _reactQuery.useQuery)(_types.QueryKeys.Settings, function () {
    return (0, _api.fetchSettings)();
  }, {
    refetchOnWindowFocus: false
  });
};

exports.useSettings = useSettings;